import { memoryStorage } from "../../lib/memory-storage.js";

export function modulesCalc() {
    const $form = document.querySelector(".section-modules__form");
    const $submitButton = $form.querySelector(".site-btn");
    const $totalsSum = document.querySelector("[data-total-price]");
    const $totalsCount = document.querySelector("[data-total-count]");

    const getSelectedModules = ($checkboxes) => {
        const selected = [];

        $checkboxes.forEach(($checkbox) => {
            if (!$checkbox.checked) {
                return;
            }

            // Цена лежит в hidden-инпуте того же .section-modules__item, но он рендерится
            // только когда у модуля задан $item["price"] (см. pages-parts/prices/modules.php)
            const $price = $checkbox.closest(".section-modules__item").querySelector("input[type='hidden']");

            selected.push({
                name: $checkbox.value,
                price: $price ? parseFloat($price.value) || 0 : 0,
            });
        });

        return selected;
    };

    $form.addEventListener("change", function(e) {
        const $checkboxes = $form.querySelectorAll(".section-modules__item input[type='checkbox']");
        const selected = getSelectedModules($checkboxes);

        const totalPrice = selected.reduce((sum, module) => sum + module.price, 0).toFixed(2);
        const totalCount = selected.length;

        $totalsSum.textContent = totalPrice;
        $totalsSum.dataset.totalPrice = totalPrice;

        $totalsCount.textContent = totalCount;
        $totalsCount.dataset.totalCount = totalCount.toString();
    });

    $submitButton.addEventListener("click", function() {
        $form.requestSubmit();
    });

    $form.addEventListener("submit", function(e) {
        e.preventDefault();

        const $checkboxes = e.target.querySelectorAll(".section-modules__item input[type='checkbox']");

        const selectedModules = getSelectedModules($checkboxes);

        memoryStorage.set("modules-data", selectedModules);
    });
}